module.exports = __webpack_public_path__ + "img/new-salon-2thumb_en.efb0dd99.png";